const endPoint = process.env.REACT_APP_BASE_END_POINT;
export const UrlHelpers = {
  createDomain: `${endPoint}/app/template-engine/v2/create-domain`,
  getTemplateMetaData: `${endPoint}/app/template-engine/v2/get-template-metadata`,
  getTemplateList: `${endPoint}/app/template-engine/v2/get-template-list`,
  fetchPresignedurl: `${endPoint}/app/template-engine/v2/fetch-presigned-url`,
  manageTemplate: `${endPoint}/app/template-engine/v2/create-template-json`,
  uploadcsv: `${endPoint}/dnotificationapi/v2/upload`,
  uploadcsvxl: `${endPoint}/dnotificationapi/v2/uploadxl`,
};
